import flotTemplate from './pieFlotChart.html';

/** @ngInject */
export function pieFlotChart() {
    return {
        scope: {
            flotService: '=',
            flotDataset: '=',
            flotOptions: '=',
            flotId: '@',
            kind: '@'
        },
        templateUrl: flotTemplate
    };
}

